import TaskTable from "./TaskTable";

const MyHistoryTable = ({ rowData, onRowClick }) => {
  return <TaskTable rowData={rowData} onRowClick={onRowClick} mode="history" />;
};

export default MyHistoryTable;
